import { compact } from '@moda/portal-stanchions';
import { CarouselPumoModuleFragment, TrunkshowPageQuery } from '../../generated/types';

type DisplayPage = NonNullable<NonNullable<TrunkshowPageQuery['trunkshowPage']>['displayPage']>;

export const getLooksModuleData = (
  displayPage: DisplayPage | null | undefined
): CarouselPumoModuleFragment[] =>
  compact(displayPage?.targetBuckets.find(({ name }) => name === 'system_looks')?.modules).filter(
    moduleSection => moduleSection.__typename === 'CarouselPumoModule'
  ) as CarouselPumoModuleFragment[];
